module.exports = __webpack_public_path__ + "media/images/smart_phone/products/senbei1-d6446fe8fee97750189c64e0bf7218f9.jpeg";